import { useCallback, useState } from 'react';
import arrowLeft from '~/assets/icons/arrow_left.svg';
import box from '~/assets/icons/box_3.svg';
import boxes from '~/assets/icons/boxes.svg';
import { CollectionImage } from '~/components/collections/CollectionImage';
import { CurrencyIcon } from '~/components/collections/CurrencyIcon';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency, ModalButtonColor, ModalType } from '~/shared';
import { useModal } from '../../hooks';
import {
	setMyBusinessShopItemPageVisible,
	useLayoutDispatch,
} from '../../redux';
import { StyledButtonsGrid } from '../AppMyBusinessAbout/AppMyBusinessAbout.styled';
import { AppMyBusinessStatItem } from '../AppMyBusinessStatItem';
import {
	StyledButtonsContainer,
	StyledContainer,
	StyledHeadContainer,
	StyledInfoGrid,
	StyledItemContainer,
	StyledItemLeftContainer,
	StyledItemRightContainer,
	StyledPrice,
	StyledPriceContainer,
	StyledShadow,
} from './AppMyBusinessShopItemPage.styled';

const itemName = 'Топливо АИ - 92';
const currentPrice = 100_000;
const maxPrice = 150_000;
const stock = 23_499;
const maxOrderCount = 50_000;
const orderPricePerItem = 379;

const AppMyBusinessShopItemPage = () => {
	const dispatch = useLayoutDispatch();
	const { showModal } = useModal();
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const [stockSelected, setStockSelected] = useState<'day' | 'month' | 'all'>(
		'day',
	);
	const [salesSelected, setSalesSelected] = useState<'day' | 'month' | 'all'>(
		'day',
	);
	const [revenueSelected, setRevenueSelected] = useState<
		'day' | 'month' | 'all'
	>('day');

	const handleChangePrice = useCallback(() => {
		showModal(
			{
				type: ModalType.BusinessChangePrice,
				title: 'Изменить стоимость товара',
				text: `Выберите в поле ниже стоимость, на товар "${itemName}"`,
				currentPrice,
				maxPrice,
				minPrice: 1,
				unit: 'л.',
				acceptButton: {
					color: ModalButtonColor.Success,
					text: 'Изменить цену',
				},
				cancelButton: { color: ModalButtonColor.Secondary, text: 'Отменить' },
			},
			(result) => {
				if (!result.isAccepted) {
					return;
				}

				// @TODO: запрос на изменение цены товара
				console.log('my-business: change item price', result.value);
			},
		);
	}, [showModal]);

	const handleOrderItem = useCallback(() => {
		showModal(
			{
				type: ModalType.BusinessOrder,
				title: 'Заказать товар',
				text: `Выберите в поле ниже кол-во товара "${itemName}", которое вы хотите заказать`,
				stockLabel: 'Товара на складе',
				stock,
				maxCount: maxOrderCount,
				minCount: 1,
				pricePerItem: orderPricePerItem,
				unit: 'л.',
				acceptButton: {
					color: ModalButtonColor.Success,
					text: 'Оплатить товар',
				},
				cancelButton: { color: ModalButtonColor.Secondary, text: 'Отменить' },
			},
			(result) => {
				if (!result.isAccepted) {
					return;
				}

				// @TODO: запрос на заказ товара
				console.log('my-business: order item', result.value);
			},
		);
	}, [showModal]);

	return (
		<StyledContainer>
			<StyledHeadContainer>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					style={{
						width: 'fit-content',
						padding: '0 10px',
						display: 'flex',
						alignItems: 'center',
						gap: 10,
						fontSize: 14,
					}}
					onClick={() => dispatch(setMyBusinessShopItemPageVisible(false))}
				>
					<img src={arrowLeft} alt="arrow-left" />
					<Text>Вернуться назад</Text>
				</Button>
				<Text>Информация о товаре</Text>
			</StyledHeadContainer>
			<StyledItemContainer>
				<StyledItemLeftContainer>
					<StyledShadow />
					<CollectionImage collection="items" id="apple" size={268} />
				</StyledItemLeftContainer>
				<Divider $direction="V" style={{ opacity: 0.1 }} />
				<StyledItemRightContainer>
					<div>
						<Text style={{ fontSize: 14, color: '#FFFFFF', opacity: 0.25 }}>
							Название товара
						</Text>
						<Text
							style={{
								fontSize: 18,
								color: '#FFFFFF',
								fontWeight: 500,
								marginTop: 4,
							}}
						>
							Топливо АИ - 92
						</Text>
						<Text
							style={{
								fontSize: 14,
								color: '#FFFFFF',
								opacity: 0.25,
								marginTop: 22,
							}}
						>
							Описание
						</Text>
						<Text
							style={{
								fontSize: 14,
								color: '#FFFFFF',
								opacity: 0.5,
								marginTop: 4,
							}}
						>
							Топливо АИ - 92 требуется для автомобилей бюджетного класса и
							меньшей мощностью, с наименьшим значением октанового числа
						</Text>
					</div>
					<div>
						<StyledPriceContainer>
							<Text style={{ fontSize: 14, color: '#FFFFFF', opacity: 0.5 }}>
								Стоимость продажи
							</Text>
							<StyledPrice>
								<Text
									style={{ fontSize: 14, color: '#FFFFFF', fontWeight: 700 }}
								>
									100 000
								</Text>
								<CurrencyIcon
									icon={rubleIcon}
									size="sm"
									color="#3491E9"
									asMask
								/>
								<Text style={{ fontSize: 14, color: '#FFFFFF', opacity: 0.5 }}>
									л.
								</Text>
							</StyledPrice>
						</StyledPriceContainer>
						<Divider
							$direction="H"
							style={{ opacity: 0.1, margin: '20px 0' }}
						/>
						<StyledButtonsContainer>
							<Button
								color={ButtonColors.Default}
								height={ButtonHeight.Height50}
								borderRadius={ButtonBorderRadius.Radius5}
								style={{
									fontSize: 16,
									display: 'flex',
									alignItems: 'center',
									gap: 10,
									padding: '0 10px',
								}}
								onClick={handleChangePrice}
							>
								<CurrencyIcon icon={rubleIcon} size="sm" />
								<Text>Изменить цену</Text>
							</Button>
							<Button
								color={ButtonColors.Buy}
								height={ButtonHeight.Height50}
								borderRadius={ButtonBorderRadius.Radius5}
								style={{
									fontSize: 16,
									display: 'flex',
									alignItems: 'center',
									gap: 10,
									padding: '0 10px',
								}}
								onClick={handleOrderItem}
							>
								<img src={box} width={14} height={14} />
								<Text>Заказать товар</Text>
							</Button>
						</StyledButtonsContainer>
					</div>
				</StyledItemRightContainer>
			</StyledItemContainer>
			<StyledInfoGrid>
				<AppMyBusinessStatItem
					title="Товара на складе"
					valueIcon={
						<ImgIcon icon={boxes} width={20} height={20} color="#3491E9" />
					}
					valueText="250 000"
					valueSubText="л."
				>
					<StyledButtonsGrid>
						<Button
							color={
								stockSelected === 'day'
									? ButtonColors.LightBlue
									: ButtonColors.Default
							}
							height={ButtonHeight.Height30}
							borderRadius={ButtonBorderRadius.Radius5}
							onClick={() => setStockSelected('day')}
						>
							<Text>День</Text>
						</Button>
						<Button
							color={
								stockSelected === 'month'
									? ButtonColors.LightBlue
									: ButtonColors.Default
							}
							height={ButtonHeight.Height30}
							borderRadius={ButtonBorderRadius.Radius5}
							onClick={() => setStockSelected('month')}
						>
							<Text>Мес.</Text>
						</Button>
						<Button
							color={
								stockSelected === 'all'
									? ButtonColors.LightBlue
									: ButtonColors.Default
							}
							height={ButtonHeight.Height30}
							borderRadius={ButtonBorderRadius.Radius5}
							onClick={() => setStockSelected('all')}
						>
							<Text>Все</Text>
						</Button>
					</StyledButtonsGrid>
				</AppMyBusinessStatItem>
				<AppMyBusinessStatItem
					title="Продажи"
					valueIcon={
						<ImgIcon icon={box} width={20} height={20} color="#3491E9" />
					}
					valueText="1 500 000"
					valueSubText="л."
				>
					<StyledButtonsGrid>
						<Button
							color={
								salesSelected === 'day'
									? ButtonColors.LightBlue
									: ButtonColors.Default
							}
							height={ButtonHeight.Height30}
							borderRadius={ButtonBorderRadius.Radius5}
							onClick={() => setSalesSelected('day')}
						>
							<Text>День</Text>
						</Button>
						<Button
							color={
								salesSelected === 'month'
									? ButtonColors.LightBlue
									: ButtonColors.Default
							}
							height={ButtonHeight.Height30}
							borderRadius={ButtonBorderRadius.Radius5}
							onClick={() => setSalesSelected('month')}
						>
							<Text>Мес.</Text>
						</Button>
						<Button
							color={
								salesSelected === 'all'
									? ButtonColors.LightBlue
									: ButtonColors.Default
							}
							height={ButtonHeight.Height30}
							borderRadius={ButtonBorderRadius.Radius5}
							onClick={() => setSalesSelected('all')}
						>
							<Text>Все</Text>
						</Button>
					</StyledButtonsGrid>
				</AppMyBusinessStatItem>
				<AppMyBusinessStatItem
					title="Выручка"
					valueIcon={
						<CurrencyIcon icon={rubleIcon} size="lg" asMask color="#3491E9" />
					}
					valueText="250 000"
				>
					<StyledButtonsGrid>
						<Button
							color={
								revenueSelected === 'day'
									? ButtonColors.LightBlue
									: ButtonColors.Default
							}
							height={ButtonHeight.Height30}
							borderRadius={ButtonBorderRadius.Radius5}
							onClick={() => setRevenueSelected('day')}
						>
							<Text>День</Text>
						</Button>
						<Button
							color={
								revenueSelected === 'month'
									? ButtonColors.LightBlue
									: ButtonColors.Default
							}
							height={ButtonHeight.Height30}
							borderRadius={ButtonBorderRadius.Radius5}
							onClick={() => setRevenueSelected('month')}
						>
							<Text>Мес.</Text>
						</Button>
						<Button
							color={
								revenueSelected === 'all'
									? ButtonColors.LightBlue
									: ButtonColors.Default
							}
							height={ButtonHeight.Height30}
							borderRadius={ButtonBorderRadius.Radius5}
							onClick={() => setRevenueSelected('all')}
						>
							<Text>Все</Text>
						</Button>
					</StyledButtonsGrid>
				</AppMyBusinessStatItem>
			</StyledInfoGrid>
		</StyledContainer>
	);
};

export { AppMyBusinessShopItemPage };
